import React, { useLayoutEffect, useRef, useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigation,
} from "react-router-dom";
import PageSkeleton from "../skeletons/PageSkeleton";

/**
 * Shows a page skeleton during router transitions without unmounting the layout
 * (keeps sidebar + workspace tab state alive in Electron mode).
 */
export function RouteLoader() {
  const navigation = useNavigation();
  const location = useLocation();
  const [flash, setFlash] = useState(false);
  const keyRef = useRef(location.key);

  useLayoutEffect(() => {
    if (location.key !== keyRef.current) {
      keyRef.current = location.key;
      setFlash(true);
      const id = requestAnimationFrame(() => {
        requestAnimationFrame(() => setFlash(false));
      });
      return () => cancelAnimationFrame(id);
    }
  }, [location.key]);

  const showOverlay = navigation.state === "loading" || flash;

  return (
    <>
      <Outlet />
      {showOverlay && (
        <div
          className="fixed inset-0 z-[200] bg-[var(--color-bg-secondary)]"
          aria-busy="true"
          aria-live="polite"
        >
          <PageSkeleton />
        </div>
      )}
    </>
  );
}

export default RouteLoader;
